<template>
  <kst-page-export
    :catalog="RcvSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :access="access"
      :userData="userData"
      @init="handleExport_init"
    />

    <kst-check disabled
      v-model="userData.WithList"
      :label="Info.Export.List.Excel.Option.List"
    />
    <kst-check 
      v-model="userData.WithItems"
      :label="Info.Export.List.Excel.Option.ReceiveItem"
    />
  </kst-page-export>
</template>

<script>
import Info from "../RcvInfo.js";
import Model from "../RcvModel.js";
import RcvSearchCatalog from "../RcvSearchCatalog.js";
import Services from "../../../services/Api/ReceiveServices.js";

import Export from "./RcvExL_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    Info: Info,
    Model: Model,
    RcvSearchCatalog: RcvSearchCatalog,
    access: {},
    searchData: {
      Search: "",
      Date: null,
      VendorID: null,
      VendorName: null,
      WarehouseID: null
    },
    userData: {
      WithList: true,
      WithItems: true
    },
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit() {
      this.resetData();
    },

    handleExport(loadExport) {
      const options = this.getListOptions();
      const config = Services.getExportList(options);
      loadExport(config, this.handleExport_success);
    },
    handleExport_success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** by export ***/

    handleExport_init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);

      this.userData.WithList = true;
      this.userData.WithItems = true;
    },

    getListOptions() {
      const vendorId = this.$kst.Out.getInteger(this.searchData.VendorID);
      const vendorName = vendorId === null
        ? this.$kst.Out.getString(this.searchData.VendorName) : null;

      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        vendor: vendorId,
        vendorname: vendorName,
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.ListFields,
        withitems: this.$kst.Out.getBoolean(this.userData.WithItems)
      };
    }
  }
}
</script>